import React, { FC, useState, useRef, useEffect } from "react";
import ShowDropdownIcon from "../../../../assets/icons/ShowDropdownIcon";

interface Option {
  code: string;
  label: string;
}

interface RegistrationCodeInputProps {
  id?: string;
  name?: string;
  value?: string;
  onChange?: (value: Option) => void;
  error?: string;
  onSelect?: () => void;
  isSlideUp?: boolean;
}

const options: Option[] = [
  { code: "BN", label: "Sole Business or Partnership" },
  { code: "RC", label: "Limited Liability Company" },
  { code: "RC", label: "Unlimited Liability Company" },
  { code: "RC", label: "Public Limited Company" },
  { code: "RC", label: "Company Limited by Guarantee" },
  { code: "LLP", label: "Limited Liability Partnership" },
];

const RegistrationCodeInput: FC<RegistrationCodeInputProps> = ({
  id,
  name,
  value,
  onChange,
  error,
  onSelect,
  isSlideUp = true,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleOptionClick = (option: Option) => {
    setSelectedOption(option);
    if (onChange) {
      onChange(option);
    }
    if (onSelect) {
      onSelect();
    }
    setIsOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <label
        htmlFor={id}
        className="text-[14px] leading-5 text-[#000000] font-medium"
      >
        Registration Code Type
      </label>
      <div className="relative">
        {isOpen && (
          <div
            className={`absolute flex flex-col md:gap-1 bg-white border border-gray-300 rounded-lg w-full z-10 shadow-md ${isSlideUp ? "animate-slide-up bottom-[45px] mb-1" : "animate-slide-down top-[45px] mt-1"}`}
          >
            {options.map((option, index) => (
              <div
                key={index}
                className="md:py-3 py-2 md:pl-5 pl-2 cursor-pointer md:text-[16px] text-[13px] hover:bg-sky-100"
                onClick={() => handleOptionClick(option)}
              >
                {/* <span className="font-medium mr-2">{`(${option.code})`}</span> */}
                {option.label}
                <span className="text-gray-500 ml-2">{`(e.g. ${option.code}123456)`}</span>
              </div>
            ))}
          </div>
        )}
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={`border relative bg-white p-2 lg:max-h-[48px] lg:min-h-[48px] md:max-h-[48px] md:min-h-[48px] h-[48px] w-full md:h-12 md:text-[16px] text-[13px] md:placeholder:text-[12px] placeholder:text-[12px] placeholder:text-[#98A2B3] rounded-lg border-[#D0D5DD] flex items-center pr-10 z-20 ${isOpen && "border-[#1C64F2]"}`}
        >
          {selectedOption ? (
            `(${selectedOption.code}) ${selectedOption.label}`
          ) : (
            <span className="text-[#98A2B3]">Select Code Type</span>
          )}
          <span
            className="absolute md:right-[14px] right-[4.7%]"
            onClick={() => setIsOpen(!isOpen)}
          >
            <ShowDropdownIcon />
          </span>
        </div>
      </div>
      {error && <p className="text-red-500">{error}</p>}
    </div>
  );
};

export default RegistrationCodeInput;
